import { Box, Typography } from '@mui/material';

import UpgradeToPremiumButton from '@/components/UpgradeToPremium/UpgradeToPremiumButton';

const PremiumWidgetDenied = () => {
  return (
    <Box
      sx={{
        position: 'relative',
        overflow: 'hidden',
        '&:before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          backgroundImage: "url('/img/preview/history-chart.png')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          filter: 'blur(5px)',
          transform: 'scale(1.05)',
          zIndex: 0
        }
      }}
    >
      <Box
        sx={{
          position: 'relative',
          zIndex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          textAlign: 'center',
          alignItems: 'center',
          gap: '8px',
          height: '542px'
        }}
      >
        <Typography>This is a Premium feature</Typography>
        <Typography>Upgrade for advanced functionality</Typography>
        <UpgradeToPremiumButton
          sx={{
            mt: '8px'
          }}
          type='upgrade'
        />
      </Box>
    </Box>
  );
};

export default PremiumWidgetDenied;
